import "../../font.css.ts.vanilla.mjs";
import "./link.css.ts.vanilla.mjs";
var e = "p273__link-efa1_fc86abca9__d1w58k3", k = "p273__link-efa1_fc86abca9__d1w58k1", i = "p273__link-efa1_fc86abca9__d1w58k0", c = "p273__link-efa1_fc86abca9__d1w58k2";
export {
  e as animateStyle,
  k as darkTheme,
  i as lightTheme,
  c as linkStyle
};
//# sourceMappingURL=link.mjs.map
